import ProductosMateriaPrimaScreen from "../../Screen/ERP/Global/Productos/ProductosMateriaPrimaScreen";

export const baseLang = {
  user: {
    en: "User",
    es: "Usuario",
  },
  users: {
    en: "Users",
    es: "Usuarios",
  },
  rol: {
    en: "Rol",
    es: "Rol",
  },
  DB: {
    en: "DB",
    es: "DB",
  },
  password: {
    en: "Password",
    es: "Contraseña",
  },
  login: {
    en: "Login",
    es: "Ingresar",
  },
  badCredentials: {
    en: "Bad credentials",
    es: "Credenciales incorrectas",
  },
  btnCerrarSecion: {
    es: "Cerrar sesión",
    en: "Logout",
  },
  btnGuardar: {
    es: "Guardar",
    en: "Save",
  },
  btnCancelar: {
    es: "Cancelar",
    en: "Cancel",
  },
  btnEliminar: {
    es: "Eliminar",
    en: "Delete",
  },
  btnEditar: {
    es: "Editar",
    en: "Edit",
  },
  btnNuevo: {
    es: "Nuevo",
    en: "New",
  },
  btnAceptar: {
    es: "Aceptar",
    en: "Accept",
  },
  btnBuscar: {
    es: "Buscar",
    en: "Search",
  },
  btnAgregar: {
    es: "Agregar",
    en: "Add",
  },
  btnCerrar: {
    es: "Cerrar",
    en: "Close",
  },
  bodega: {
    en: "Warehouse",
    es: "Bodega",
  },
  estante: {
    en: "Shelving",
    es: "Estante",
  },
  posicion: {
    en: "Rows",
    es: "Filas",
  },
  tipoProducto: {
    en: "Product Types",
    es: "Tipos de Productos",
  },
  moneda: {
    en: "Currencies",
    es: "Monedas",
  },
  pais: {
    en: "Countries",
    es: "Países",
  },
  tipo: {
    en: "Types",
    es: "Tipos",
  },
  Prioridades: {
    en: "Priorities",
    es: "Prioridades",
  },
  producto: {
    en: "Products",
    es: "Productos",
  },
  ProductosMateriaPrimaScreen: {
    en: "Products Raw Material",
    es: "Productos de Materia Prima",
  },
  rol: {
    en: "Rols",
    es: "Roles",
  },
  acceso: {
    en: "Access",
    es: "Accesos",
  },
  sesion: {
    en: "Sessions",
    es: "Sesiones",
  },
  unidad: {
    en: "Units Measurement",
    es: "Unidad de Medida",
  },
  categoria: {
    en: "Categories",
    es: "Categorías",
  },
  subcategoria: {
    en: "SubCategories",
    es: "SubCategorías",
  },
  bodega: {
    en: "Werehouse",
    es: "Bodegas",
  },
  proveedor: {
    en: "Suppliers",
    es: "Proveedores",
  },
  customer: {
    en: "Customers",
    es: "Clientes",
  },
  areas: {
    en: "Areas",
    es: "Áreas",
  },
  ordenes: {
    en: "Purchase Orders",
    es: "Ordenes Compra",
  },
  requisas: {
    en: "Purchase Request",
    es: "Requisas Compras",
  },
  liberarRequisas: {
    en: "Release Requisitions",
    es: "Liberar Requisas",
  },
  liberarBodega: {
    en: "Release Warehouse",
    es: "Liberar Bodega",
  },
  aprobarRequisa: {
    en: "Approve Requisitions",
    es: "Aprobar Requisa",
  },
  ingresos: {
    en: "Warehouse Income",
    es: "Ingresos Bodega",
  },
  ingresosMP: {
    en: "Raw Material Income",
    es: "Ingresos Materia Prima",
  },
  requisasMateriales: {
    en: "Material Requisitions",
    es: "Requisas Materiales",
  },
  termino: {
    en: "Terms",
    es: "Términos",
  },
  customerDetails: {
    en: "Customer Details",
    es: "Detalles de Clientes",
  },
  proveedorCAI: {
    en: "CAI Supplier",
    es: "Proveedores CAI",
  },
  userAccess: {
    en: "Access",
    es: "Acceso",
  },
  rolAccess: {
    en: "Roles with Access",
    es: "Roles con Acceso",
  },
  userPermiso: {
    en: "Permission to",
    es: "Permiso a",
  },
  rolPermiso: {
    en: "Roles with Permission to",
    es: "Roles con Permisos a",
  },
  permisosGenerales: {
    en: "General Permission",
    es: "Permisos Generales",
  },
  menu: {
    en: "Menu",
    es: "Menú",
  },
  liberarRequisaMateriales: {
    es: "Liberar Requisas de Materiales",
    en: "Release Material Requisitions",
  },
  autorizarRRHH: {
    es: "Autorizar RRHH",
    en: "Authorize HR",
  },
  autorizarMASS: {
    es: "Autorizar MASS",
    en: "Authorize MASS",
  },
  salidasMateriales: {
    es: "Salidas de Materiales",
    en: "Material Outputs",
  },
  SalidasMP: {
    es: "Salidas de Materia Prima",
    en: "Raw Material Outputs",
  },
  devolucionesI: {
    es: "Devoluciones Internas",
    en: "Internal Returns",
  },
  devolucionesP: {
    es: "Devoluciones a Proveedor",
    en: "Returns to Supplier",
  },
  listadoIngresosDevPro: {
    es: "Listado de Ingresos",
    en: "Income List",
  },
  listadoSalidasDevInt: {
    es: "Listado de Salidas",
    en: "Departure List",
  },
  salidasM: {
    es: "Salidas de Material",
    en: "Salidas de Material",
  },
  tipoTrabajo: {
    es: "Tipo de Trabajo",
    en: "Type of Job",
  },
  tipoParo: {
    es: "Tipo de Paro",
    en: "Stop Type",
  },
  tipoMantenimiento: {
    es: "Tipo de Mantenimiento",
    en: "Maintenance Type",
  },
  calendarioO: {
    es: "Calendario Operativo",
    en: " Operational Calendar",
  },
  listaCorreos: {
    es: "Lista de destinatarios Correos",
    en: "Email recipient list",
  },
  destinatarios: {
    es: "Destinatarios de Correo",
    en: "Email Recipients",
  },
  posicionRHH: {
    es: "Posiciones",
    en: "Positions",
  },
  personalRRHH: {
    es: "Personal",
    en: "Staff",
  },
  activoFijo: {
    es: "Activos Fijos",
    en: "Fixed Assets",
  },
  ordenTrabajo: {
    es: "Ordenes de Trabajo",
    en: "Work Orders",
  },
  bandeja: {
    es: "Bandeja",
    en: "Tray",
  },
  informacionEmpresa: {
    es: "Información de la Empresa",
    en: "Company Information",
  },

  //---------------------------------------------------------------------------REQUISAS COMPRAS ---------------------------------------------------------------------
  requisasTab: {
    es: "Detalles",
    en: "Datils",
  },
  listadoTab: {
    es: "Listado",
    en: "List",
  },
  buscar: {
    es: "Buscar",
    en: "Search",
  },
  recargar: {
    es: "Refrescar",
    en: "Refresh",
  },
  nueva: {
    es: "Nueva",
    en: "New",
  },
  adjuntos: {
    es: "Adjuntos",
    en: "Attachments",
  },
  cancelar: {
    es: "Cancelar",
    en: "Cancel",
  },
  reporte: {
    es: "Reporte",
    en: "Report",
  },

  //CRUD
  NoRequisa: {
    es: "No. Requisa",
    en: "No. Requisition",
  },
  dateC: {
    es: "Fecha Creación",
    en: "Date Create",
  },
  estado: {
    es: "Estado",
    en: "Status",
  },
  usuario: {
    es: "Usuario",
    en: "User",
  },
  prioridad: {
    es: "Prioridad",
    en: "Priority",
  },
  tipo: {
    es: "Tipo",
    en: "Type",
  },
  area: {
    es: "Área",
    en: "Area",
  },
  solicita: {
    es: "Solicita",
    en: "Request",
  },
  asignado: {
    es: "Asignado a",
    en: "Assigned to",
  },
  comentario: {
    es: "Comentario",
    en: "Comment",
  },
  calculo: {
    es: "Cálculo ISV 15%: ",
    en: "Calculate TAX 15%: ",
  },

  //---------------------------------------------------------------------------ORDENES COMPRAS ---------------------------------------------------------------------
  detallesTab: {
    es: "Detalles",
    en: "Datils",
  },
  ordenesTab: {
    es: "Listado",
    en: "List",
  },
  // CRUD
  NoOrden: {
    es: "No. Orden",
    en: "No. Order",
  },
  agente: {
    es: "Agente",
    en: "Agent",
  },
  cliente: {
    es: "Cliente",
    en: "Customer",
  },
  entregar: {
    es: "Entregar a",
    en: "Deliver to",
  },
  tipoC: {
    es: "Tipo de Compra",
    en: "Purchase Type",
  },
  terminoC: {
    es: "Término de Compra",
    en: "Purchase Term",
  },
  terminoI: {
    es: "Término Inco",
    en: "Inco Term",
  },
  moneda: {
    es: "Moneda",
    en: "Currency",
  },
  bodega: {
    es: "Bodega",
    en: "Warehouse",
  },
  item: {
    es: "Agregar artículo",
    en: "Add items",
  },
  guardar: {
    es: "Guardar",
    en: "Save",
  },
  editar: {
    es: "Editar",
    en: "Edit",
  },
  eliminar: {
    es: "Eliminar",
    en: "Delete",
  },
  descuento: {
    es: "Descuento",
    en: "Discount",
  },
  agregarR: {
    es: "Agregar Requisas",
    en: "Add Requests",
  },
  ordenC: {
    es: "Orden de Compras",
    en: "Purchase Order",
  },

  // ----------------------------------------------------------------TOAST------------------------------------------------------------------------
  advertencia: {
    es: "Advertencia",
    en: "Warning",
  },
  rangoF: {
    es: "Por favor, seleccione un rango de fechas válido.",
    en: "Please select a valid date range.",
  },
  imprimirReporte: {
    es: "Seleccione una órden a imprimir.",
    en: "Select an order to print.",
  },
  noEncontrada: {
    es: "La orden de compra que desea buscar no existe.",
    en: "The purchase order you want to search for does not exist.",
  },

  errorProveedor: {
    es: "Seleccione un proveedor.",
    en: "Select a supplier.",
  },
  errorCliente: {
    es: "Seleccione un cliente.",
    en: "Select a client.",
  },
  errorAgente: {
    es: "Seleccione un Agente.",
    en: "Select an agent.",
  },
  errorTermino: {
    es: "Seleccione un término de compras.",
    en: "Select a purchase term.",
  },
  errorTerminoInco: {
    es: "Seleccione un término de compras.",
    en: "Select an Inco Term.",
  },
  errorTipoCompra: {
    es: "Seleccione el tipo de compra.",
    en: "Select the type of purchase.",
  },
  errorArea: {
    es: "Seleccione Área.",
    en: "Select Area.",
  },
  errorBodega: {
    es: "Seleccione Bodega.",
    en: "Select Warehouse.",
  },
  errorMoneda: {
    es: "Seleccione Moneda.",
    en: "Select Currency.",
  },
  errorClienteDetalle: {
    es: "Seleccione lugar de entrega.",
    en: "Select delivery location.",
  },

  imprimirReq: {
    es: "Seleccione solo una requisa.",
    en: "Select only one request.",
  },
  imprimirReq1: {
    es: "Seleccione una requisa.",
    en: "Select one request.",
  },
  detalleEnOC: {
    es: "El Detalle de requisa seleccionado ya está en una orden de compra.",
    en: "The selected Requisition Detail is already on a purchase order.",
  },
  detalleEnOC: {
    es: "El Detalle de requisa seleccionado ya está cancelados.",
    en: "The selected request detail is already canceled.",
  },
  mensajeExitoCancelar: {
    es: "Requisa cancelada correctamente.",
    en: "Requisition canceled correctly.",
  },
  mensajeExitoCancelar1: {
    es: "Detalle de requisa cancelado correctamente.",
    en: "Requisition detail canceled correctly.",
  },
  mensajeErrorCancelar: {
    es: "Error al cancelar el detalle de la requisición.",
    en: "Error when canceling the requisition detail.",
  },
  mensajeErrorCancelar1: {
    es: "Error al cancelar la requisa.",
    en: "Error canceling the requisition.",
  },
  detalleRequisa: {
    es: "Seleccione al menos un detalle de la requisa.",
    en: "Select at least one request detail.",
  },
  cancel: {
    es: "Cancelado",
    en: "Cancel",
  },
  guardado: {
    es: "Guardado",
    en: "Saved",
  },
  errorObtener: {
    es: "No se encontro la requisa.",
    en: "The search was not found.",
  },
  seleccioneProducto: {
    es: "Seleccione al menos un producto.",
    en: "Select at least one product.",
  },
  productoCantidad: {
    es: "Todos los items deben contener un producto y una cantidad.",
    en: "All items must contain a product and a quantity.",
  },
  editada: {
    es: "Editada",
    en: "Edited",
  },
  editado: {
    es: "Editado",
    en: "Edited",
  },
  guardada: {
    es: "Guardada",
    en: "Saved",
  },
  guardado: {
    es: "Guardado",
    en: "Saved",
  },
  eliminarItem: {
    es: "¿Esta seguro que desea eliminar este item?",
    en: "Are you sure you want to delete this item?",
  },
  editarProveedor: {
    es: "No se puede editar el proveedor cuando ya existe una orden de compra.",
    en: "You cannot edit the supplier when a purchase order already exists.",
  },
  guardeReq: {
    es: "Guarde la el detalle de requisa antes de agregar el proveedor.",
    en: "Save the requisition detail before adding the supplier.",
  },
  proveedorAntesPrecio: {
    es: "Debe seleccionar un proveedor antes de ingresar el precio.",
    en: "You must select a supplier before entering the price.",
  },
  correoGerente: {
    es: "¿Desea enviar un correo al Gerente?",
    en: "Do you want to send an email to the Manager?",
  },
  titleCorreoGerente: {
    es: "Enviar Correo",
    en: "Send Email",
  },
  correoAgente: {
    es: "¿Desea enviar un correo a Agente de Compras?",
    en: "Do you want to send an email to Purchase Agent?",
  },
  si: {
    es: "Si",
    en: "Yes",
  },
  crearNuevaR: {
    es: "¿Está seguro de que desea crear una nueva Requisa?",
    en: "Are you sure you want to create a new Requisition?",
  },
  nuevaR: {
    es: "Nueva Requisa",
    en: "New Requisition",
  },
  sPrioridad: {
    es: "Debe seleccionar la prioridad.",
    en: "You must select the priority.",
  },
  sTipo: {
    es: "Debe seleccionar el tipo.",
    en: "You must select the type.",
  },
  sDepartamento: {
    es: "Debe seleccionar un departamento.",
    en: "You must select a department.",
  },
  sSolicita: {
    es: "Debe seleccionar el solicitante.",
    en: "Applicant must select.",
  },
  sComentario: {
    es: "Debe ingresar un comentario.",
    en: "You must enter a comment.",
  },
  sRequisa: {
    es: "Debe seleccionar una Requisa.",
    en: "You must select a Requisition.",
  },
  cancelado: {
    es: "Cancelado.",
    en: "Canceled",
  },
  canceladoCorrecto: {
    es: "Archivo de requisa eliminado correctamente.",
    en: "Requisition file deleted successfully.",
  },
  eliminado: {
    es: "Eliminado.",
    en: "Deleted",
  },
  msjExitoEliminado: {
    es: "Link Eliminado Correctamente.",
    en: "Link Correctly Deleted",
  },
  enlace: {
    es: "Enlace de Compra.",
    en: "Purchase Link",
  },
  descripcion: {
    es: "Descripción.",
    en: "Description",
  },
  abrirEnlace: {
    es: "Abrir enlace de compra.",
    en: "Open purchase link",
  },
  enlacesTab: {
    es: "Enlaces de Compra",
    en: "Purchase Links",
  },
  archivosTab: {
    es: "Agregar Archivos",
    en: "Add Files",
  },

  // -----------------------------------------------BODEGA-------------------------------------------------
  imprimir: {
    es: "Imprimir",
    en: "Print",
  },
  nuevo: {
    es: "Nuevo",
    en: "New",
  },
  imprimirEtiqueta: {
    es: "Imprimir Etiqueta",
    en: "Print Label",
  },
  elejirEtiqueta: {
    es: "Elija la etiqueta que desea Imprimir.",
    en: "Choose the label you want to print",
  },
  qr: {
    es: "Código QR",
    en: "QR Code",
  },
  barras: {
    es: "Código de Barras",
    en: "Bar Code",
  },
  sinImg: {
    es: "El Producto no tiene imágenes.",
    en: "The Product does not have images.",
  },

  // CRUD PRODUCTOS
  nombreProducto: {
    es: "Nombre Producto",
    en: "Product Name",
  },
  ncategoria: {
    es: "Categoría",
    en: "Category",
  },
  nSubcategoria: {
    es: "SubCategoría",
    en: "SubCategory",
  },
  ntipoProducto: {
    es: "Tipo de Producto",
    en: "Product Type",
  },
  minimo: {
    es: "Cantidad Mínimo",
    en: "Minimum Quantity",
  },
  maximo: {
    es: "Cantidad Máxima",
    en: "Maximum Quantity",
  },
  unidad: {
    es: "Unidades",
    en: "Units",
  },

  // BODEGAS
  nombreBodega: {
    es: "Nombre Bodega",
    en: "Warehouse Name",
  },
  accesoBod: {
    es: "Acceso de Despacho",
    en: "Dispatch Access",
  },
  modificarBod: {
    es: "Editar Bodega",
    en: "Edit Warehouse",
  },
  agregarBod: {
    es: "Agregar Bodega",
    en: "Add Warehouse",
  },
  nombreIgual: {
    es: "Ya existe una bodega con ese nombre",
    en: "There is already a winery with that name",
  },
  nombreIgual: {
    es: "Ya existe una bodega con ese nombre",
    en: "There is already a warehouse with that name",
  },
  datosAgregados: {
    es: "Datos Agregados",
    en: "Aggregated Data",
  },
  exitoAgregarBod: {
    es: "Bodega agregada exitosamente.",
    en: "Warehouse successfully added.",
  },
  exitoEditadaBod: {
    es: "Bodega editada exitosamente.",
    en: "Warehouse successfully edited.",
  },

  // ESTANTES
  nombreEstante: {
    es: "Nombre Estante",
    en: "Shelf Name",
  },
  numeroEstante: {
    es: "Número Estante",
    en: "Shelf Number",
  },
  editarEstante: {
    es: "Editar Estante",
    en: "Edit Shelf",
  },
  agregarEstante: {
    es: "Agregar Estante",
    en: "Add Shelf",
  },
  nombreIgualEst: {
    es: "Ya existe un estante con ese nombre en la bodega seleccionada",
    en: "A shelf with that name already exists in the selected warehouse",
  },
  datosAgregados: {
    es: "Datos Agregados",
    en: "Aggregated Data",
  },
  exitoAgregarEst: {
    es: "Estante agregado exitosamente.",
    en: "Shelf added successfully.",
  },
  exitoEditEst: {
    es: "Estante editado exitosamente.",
    en: "Successfully edited shelf.",
  },

  // POSICIONES
  editarPos: {
    es: "Editar Fila",
    en: "Edit Row",
  },
  agregarPos: {
    es: "Agregar Fila",
    en: "Add Row",
  },
  nombrePos: {
    es: "Nombre",
    en: "Name",
  },
  numeroPos: {
    es: "Número",
    en: "Number",
  },

  //BANDEJA
  nombreIgualBand: {
    es: "Ya existe una Bandeja con el mismo nombre en este Estante.",
    en: "A Tray with the same name already exists on this Shelf.",
  },
  editarBandeja: {
    es: "Editar Bandeja",
    en: "Edit Tray",
  },
  agregarBandeja: {
    es: "Agregar Bandeja",
    en: "Add Tray",
  },
  lado: {
    es: "Lado",
    en: "Side",
  },
  sOtraBod: {
    es: "Seleccione otra Bodega",
    en: "Select another Warehouse",
  },
  bodSinEstantes: {
    es: "La Bodega seleccionada no cuenta con estantes disponibles.",
    en: "The selected warehouse does not have available shelves.",
  },
  sOtroEst: {
    es: "Seleccione otro Estante",
    en: "Select another Shelf",
  },
  estSinPosiciones: {
    es: "El Estante seleccionado no cuenta con Filas disponibles.",
    en: "The selected Shelf does not have available Rows.",
  },

  //INGRESOS BODEGA
  ingresoEliminado: {
    es: "El ingreso seleccionado ya está eliminado.",
    en: "The selected warehouse entry is already deleted.",
  },
  seleccioneIngreso: {
    es: "Seleccione al menos un detalle del ingreso.",
    en: "Select at least one income detail.",
  },
  cerrarSinGuardar: {
    es: "¿Estás seguro de cerrar sin guardar los cambios?",
    en: "Are you sure you can close without saving the changes?",
  },
  confEliminar: {
    es: "¿Estás seguro de que deseas eliminar?",
    en: "Are you sure you want to delete?",
  },
  confirmacion: {
    es: "Confirmación",
    en: "Confirmation",
  },
  errObtIngreso: {
    es: "Error al obtener ingreso",
    en: "Error when obtaining warehouse entry",
  },
  valoresRepetidos: {
    es: "No se permiten valores repetidos.",
    en: "Repeated values ​​are not allowed",
  },
  sOrdenC: {
    es: "Seleccione al menos una orden de compra.",
    en: "Select at least one purchase order.",
  },
  precioCantidad: {
    es: "Agregue el Precio y la cantidad a ingresar.",
    en: "Add the Price and the quantity to enter.",
  },
  bodDet: {
    es: "Ingrese la bodega en todos los detalles.",
    en: "Enter the warehouse in all data.",
  },
  estDet: {
    es: "Ingresar el estante en todos los detalles.",
    en: "Enter the shelf in all details.",
  },
  filaDet: {
    es: "Ingresar la fila en todos los detalles.",
    en: "Enter the row in all details.",
  },
  sOrdenCItem: {
    es: "Todos los items deben contener una orden de compra.",
    en: "All items must contain a purchase order..",
  },
  sOrdenCItem: {
    es: "Todos los items deben contener una orden de compra..",
    en: "All items must contain a purchase order..",
  },
  seleccioneDetalle: {
    es: "Seleccione al menos un detalle.",
    en: "Select at least one detail.",
  },
  detalleCancelado: {
    es: "El Detalle de ingreso seleccionado ya está cancelado.",
    en: "The selected Entry Detail is already cancelled.",
  },
  cantidadMayor: {
    es: "La cantidad ingresada es mayor que la cantidad de la orden de compra.",
    en: "The quantity entered is greater than the purchase order quantity.",
  },
  addProducto: {
    es: "Agregue el producto.",
    en: "Add the product.",
  },
  addCantidad: {
    es: "Agregue la Cantidad.",
    en: "Add Quantity",
  },
  sProveedor: {
    es: "Seleccione un Proveedor.",
    en: "Select a Provider.",
  },
  sProveedor: {
    es: "Seleccione un Proveedor.",
    en: "Select a Provider.",
  },
  iFactura: {
    es: "Ingrese una Factura.",
    en: "Enter an Invoice.",
  },
  iFactura: {
    es: "Ingrese una Factura.",
    en: "Enter an Invoice.",
  },
  iTasa: {
    es: "Ingrese la Tasa de Cambio.",
    en: "Enter the Exchange Rate.",
  },
  errTasa: {
    es: "La Tasa de Cambio solo puede contener números y un solo punto.",
    en: "The Exchange Rate can only contain numbers and a single point.",
  },
  sTermino: {
    es: "Seleccione un Término de Compra.",
    en: "Select a Purchase Term.",
  },
  nuevoIngreso: {
    es: "¿Está seguro que desea crear un nuevo Ingreso?",
    en: "Are you sure you want to create a new werehouse entry?.",
  },
  noIngreso: {
    es: "No. Ingreso",
    en: "No. Income",
  },
  fechaFact: {
    es: "Fecha Factura",
    en: "Invoice Date",
  },
  fact: {
    es: "Factura",
    en: "Invoice",
  },
  tasaCambio: {
    es: "Tasa de Cambio",
    en: "Exchange Rate",
  },
  addSinPO: {
    es: "Agregar sin PO",
    en: "Add without PO",
  },
  addConPO: {
    es: "Agregar con PO",
    en: "Add with PO",
  },
  agregarOrdenes: {
    es: "Agregar Ordenes",
    en: "Add Orders",
  },
  agregarOrdenes: {
    es: "Agregar Ordenes",
    en: "Add Orders",
  },

  // ---------------------------------------------REQUISAS DE MATERIALES-----------------------------------------------------
  detalleEliminado: {
    es: "El detalle seleccionado ya está eliminado.",
    en: "The selected detail is already deleted.",
  },
  requisaEliminado: {
    es: "La requisa seleccionada ya está eliminada.",
    en: "The selected requisition is already deleted.",
  },
  sUnaRequisa: {
    es: "Seleccione al menos una requisa.",
    en: "Select at least one request.",
  },
  itemConProductos: {
    es: "Todos los items deben contener un Producto.",
    en: "All items must contain a Product.",
  },
  itemConComentarios: {
    es: "Todos los items deben contener un Comentario.",
    en: "All items must contain a Comment.",
  },
  noPuedeser0: {
    es: "Cantidad Solicitada no puede ser 0",
    en: "Requested Quantity cannot be 0",
  },
  cantMayorInventario: {
    es: "La cantidad no debe ser mayor que el inventario.",
    en: "The quantity must not be greater than the inventory.",
  },
  sUser: {
    es: "Seleccione un usuario.",
    en: "Select a user.",
  },
  sArea: {
    es: "Seleccione Área.",
    en: "Select Area.",
  },
  userAuth: {
    es: "Usuario Autoriza.",
    en: "User Authorize",
  },
  addIngreso: {
    es: "Agregar Ingreso",
    en: "Add Income",
  },
  eliminarReq: {
    es: "¿Está seguro que desea eliminar la requisa?",
    en: "Are you sure you want to delete the request?",
  },
  msjEliminarReq: {
    es: "Al eliminar la requisa, se eliminaran los detalles ingresados que pertenecen a esta requisa.",
    en: "When deleting the search, the details entered that pertain to this search will be deleted.",
  },
  eliminarDet: {
    es: "¿Está seguro que desea eliminar este item?",
    en: "Are you sure you want to delete this item?",
  },
  comentarioCancelacion: {
    es: "Comentario cancelación",
    en: "Comment cancellation",
  },

  // Mensajes
  msgError: {
    es: "Error",
    en: "Error",
  },
  msgSuccess: {
    es: "Éxito",
    en: "Success",
  },
  msgWarning: {
    es: "Advertencia",
    en: "Warning",
  },

  editarUsuario: {
    es: "Editar usuario",
    en: "Edit user",
  },
  nuevoUsuario: {
    es: "Nuevo usuario",
    en: "New user",
  },
  eliminarUsuario: {
    es: "Eliminar usuario",
    en: "Delete user",
  },
  eliminarUsuarioMsg: {
    es: "¿Está seguro de eliminar el usuario?",
    en: "Are you sure to delete the user?",
  },
  configuracion: {
    es: "Configuración",
    en: "Configuration",
  },
  idioma: {
    es: "Idioma",
    en: "Language",
  },
  tema: {
    es: "Tema",
    en: "Theme",
  },
  inicio: {
    es: "Inicio",
    en: "Home",
  },
  msgConfigGuardada: {
    es: "Configuración guardada.",
    en: "Configuration saved.",
  },
  msgErrorConfig: {
    es: "Error al guardar la configuración.",
    en: "Error saving configuration.",
  },

  listadoDeSalidas: {
    es: "Listado de Salidas",
    en: "Departure List",
  },
  inventarioS: {
    es: "Inventario",
    en: "Inventory",
  },
  inventarioMP: {
    es: "Inventario Materia Prima",
    en: "Raw Material Inventory",
  },

  asignaciones: {
    es: "Asignaciones",
    en: "Assignments",
  },

  activo: {
    es: "Activo",
    en: "Active",
  },

  fechaCreat: {
    es: "Fecha Creado",
    en: "Date Created",
  },

  areaGeneral: {
    es: "Area General",
    en: "General Area",
  },

  categoria: {
    es: "Categoría",
    en: "Category",
  },

  codActivo: {
    es: "Código Activo",
    en: "Active Cod",
  },

  tipoMantenimiento: {
    es: "Tipo Mantenimiento",
    en: "Maintenance Type",
  },

  tipoTrabajo: {
    es: "Tipo Trabajo",
    en: "Type of Work",
  },

  descripcion: {
    es: "Descripción",
    en: "Description",
  },
  metricas: {
    es: "Métricas",
    en: "Metricas",
  },
  regmetricas: {
    es: "Registro Métricas",
    en: "Metrics Log",
  },
  vehiculos: {
    es: "Vehículos",
    en: "Vehicles",
  },
  motoristas: {
    es: "Motoristas",
    en: "Drivers",
  },
  pasesDeSalida: {
    es: "Pases de Salida",
    en: "Pases de Salida",
  },
  lotes: {
    es: "Lotes",
    en: "Lots",
  },
  notificacion: {
    es: "Notificaciones",
    en: "Notifications",
  },
  contenido: {
    es: "Contenido",
    en: "Content",
  },
  enviar: {
    es: "Enviar a",
    en: "Send to",
  },
  enviarText: {
    es: "Enviar",
    en: "Send",
  },
  requisaMateriaPrima: {
    es: "Requisas Materia Prima",
    en: "Raw Material Requisitions",
  },
  liberarRequisaMateriaPrima: {
    es: "Liberar requisas de Materia Prima",
    en: "Release raw Material requisitions",
  },

  //DESARROLLO
  desc: {
    es: "Descripción",
    en: "Description",
  },
  Recycled: {
    es: "Reciclado",
    en: "Recycled",
  },
  "Types Cotton": {
    es: "Tipos Algodón",
    en: "Types Cotton",
  },
  Composición: {
    es: "Composición",
    en: "Composition",
  },
  "Agregar Composición de Algodón": {
    es: "Agregar Composición de Algodón",
    en: "Add cotton composition",
  },
  Fibras: {
    es: "Fibras",
    en: "Fibers",
  },
  Fibra: {
    es: "Fibra",
    en: "Fiber",
  },
  "Agregar Fibra": {
    es: "Agregar Fibra",
    en: "Add Fiber",
  },
  Efectos: {
    es: "Efectos",
    en: "Effects",
  },
  Efecto: {
    es: "Efecto",
    en: "Effect",
  },
  "Agregar Efecto": {
    es: "Agregar Efecto",
    en: "Add Effect",
  },
  Spinning: {
    es: "Hilado",
    en: "Spinning",
  },
  "Agregar Spinning": {
    es: "Agregar Hilado",
    en: "Add Spinning",
  },
  Calibres: {
    es: "Calibres",
    en: "Calibers",
  },
  Calibre: {
    es: "Calibre",
    en: "Caliber",
  },
  "Agregar Calibre": {
    es: "Agregar Calibre",
    en: "Add Caliber",
  },
  Yarn: {
    es: "Yarn",
    en: "Hilo",
  },
  "Planillas": {
    es: "Planillas",
    en: "Payrolls",
  },
  "Turnos": {
    es: "Turnos",
    en: "Shifts",
  },
  "Motivos de Pago": {
    es: "Motivos de Pago",
    en: "Payment Reasons",
  },
  "Motivos de Deducciones": {
    es: "Motivos de Deducciones",
    en: "Deduction Reasons",
  },
  "Maestros": {
    es: "Maestros",
    en: "Masters",
  },

  //FINANZAS

  TipoCuenta: {
    en: "Accounts Types",
    es: "Tipos de Cuentas",
  },
  NotasCredito:{
    en:"Supplier Credit Notes",
    es:"Notas de Crédito de Proveedores"
  },
  "Libro Diario":{
    en:"Journal Book",
    es:"Libro Diario"
  },

  //Rangos Documentos
  Rangos:{
    en:"Document Ranges",
    es:"Rangos Documentos"
  },
  Conceptos:{
    en:"Retention Concepts",
    es:"Conceptos de Retención"
  },
  Comprobante:{
    en:"Withholding Receipt",
    es:"Comprobante de Retención"
  },
  OrdenesVenta:{
    es:"Ordenes de Ventas",
    en:"Sales Orders",
  },

  'No. Orden':{
    es:"No. Orden",
    en:"No. Order",
  },
  OrdenC:{
    es:"Orden Cliente",
    en:"Customer Order",
  },
  Agente:{
    es:"Agente de Ventas",
    en:"Sales Agent",
  },
  Fecha:{
    es:"Fecha",
    en:"Date",
  },
  Cliente:{
    es:"Cliente",
    en:"Customer",
  },
  terminoEnvio:{
    es:"Término de Envío",
    en:"Shipping term",
  },
  terminoVenta:{
    es:"Término de Venta",
    en:"Term of sale",
  },
  ordenVenta:{
    es:"Orden de Venta",
    en:"Sales Order",
  },
  agregarDetalle:{
    es:"Agregar Detalle",
    en:"Add Details",
  },
  nuevaOrden:{
    es:"Nueva Orden",
    en:"New Order",
  },
  cargar:{
    es:"Refrescar",
    en:"Refresh",
  },
  formato:{
    es:"Formato",
    en:"Format",
  },
  crearNuevaOrden:{
    es:"Crear una nueva orden",
    en:"Create a new order",
  },
  "crearNuevaOrdenConsulta":{
    es:"¿Está seguro que desea crear nueva orden?",
    en:"Are you sure you want to create a new order?",
  },
  Aranceles: {
    es: "Aranceles",
    en: "Tariffs",
  },
  'Agregar Aranceles': {
    es: "Agregar Aranceles",
    en: "Add Tariffs",
  },
  'Editar Aranceles': {
    es: "Editar Aranceles",
    en: "Edit Tariffs",
  },
  'Código': {
    es: "Código",
    en: "Code",
  },
  'Arancel': {
    es: "Arancel",
    en: "Tariff",
  },
  "Dispositivos":{
    es:"Dispositivos",
    en:"Devices"
  },
  construcciones:{
    es: 'Construcciones en proceso',
    en: 'Process Builds',
  },
  tituloSubConstrucciones:{
    en: 'Sub-construction Work in Progress',
    es: 'Subconstrucciones en Proceso'
  },
  notificaciones:{
    es: 'Notificaciones',
    en: 'Notifications'
  },
  Extensiones: {
    es: 'Extensiones',
    en: 'Extensions',
  },
  'Boleta de Compra': {
    es: 'Boleta de Compra',
    en: 'Purchase Ticket',
  },
  'ComprobantesCajaChica': {
    es: 'Comprobantes de Caja Chica',
    en: 'Petty Cash Receipts',
  },

};